var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeshift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    alt: "Logo for Shapeshift",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shapeshift") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 31.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.516 22.0915L59.1741 29.4017H42.0284L24.4839 22.0029L28.4713 46.0601L24.6612 59.0855L34.6296 65.0666C39.3701 67.902 43.579 71.4021 47.212 75.5667L51.1108 79.9971L55.1867 75.3008C58.6868 71.2692 62.7627 67.8577 67.2818 65.0666L77.073 59.0855L73.5287 46.0601L77.516 22.0915ZM65.3767 62.7185C62.0539 64.8008 58.9526 67.1932 56.1614 69.8957L52.75 66.1742L65.3767 62.7185ZM49.25 66.1742L45.9272 69.8514C43.0917 67.1489 39.9904 64.8008 36.6676 62.7628L49.25 66.1742ZM45.9715 62.1425L28.3384 57.3577L30.7308 49.1171L45.9715 62.1425ZM39.3258 31.5283L30.9524 42.4715L28.3827 26.9207L39.3258 31.5283ZM67.9463 47.6994L50.9778 62.4969L33.6992 47.6994H67.9463V47.6994ZM33.079 44.6424L42.4714 32.4144H58.7311L69.1425 44.6424H33.079ZM71.1362 48.8956L73.4401 57.3577L55.9399 62.1868L71.1362 48.8956ZM73.6616 26.8764L71.0919 42.2942L61.9653 31.5283L73.6616 26.8764Z",
    fill: "#0E182D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 31.5,
    stroke: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeshift);
export default __webpack_public_path__ + "static/media/shapeshift.2f528a3bd16c911ac532f221e67bd12e.svg";
export { ForwardRef as ReactComponent };